// src/components/ProtectedRoute.js

import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { authTokens } = useContext(AuthContext);

  return authTokens && authTokens.access ? children : <Navigate to="/" />;
};

export default ProtectedRoute;
